import template from './rendezvenyek-kereso.pug';
import rendezvenyekServiceModule from '../rendezvenyek-service';
import duScroll from 'angular-scroll';
import getUrlParams from '../../../common/getallurlparams/getallurlparams';
const MODULE_NAME = 'rendezvenyekKereso';
class RendezvenyekKeresoController {
	constructor(rendezvenyekService, $scope, $filter, $document) {
		'ngInject';
		this._rendezvenyekService = rendezvenyekService;
		this._$scope = $scope;
		this._$filter = $filter;
		this._$document = $document;
		this.getDayClass = this.getDayClass.bind(this);
	}
	$onInit() {
		this.currentPage = getUrlParams().page || 1;
		this.pageFilter = {
			rows: this.pageNumber || 10,
			start: this.currentPage - 1
		};
		this._getKategoriak();
		this.filter = {};
		this._naptar();
		this._$scope.$watch('$ctrl.model.kategoria', (newVal) => {
			this.lista({ kategoria: newVal });
		});
		this.datePickerOptions = {
			formatDayTitle: 'yyyy MMMM',
			showWeeks: false,
			customClass: this.getDayClass
		};
	}
	_getKategoriak() {
		this._rendezvenyekService.getKategoriak().then((response) => {
			this.kategoriak = response;
		}, () => {
			this.technikaiHiba = true;
		});
	}
	getPageHref(page) {
		return `${location.protocol}//${location.host}${location.pathname}?page=${page}`;
	}
	lapozas() {
		this.pageFilter.start = (this.currentPage - 1) * this.pageFilter.rows;
		this.lista();
		var topAnchor = angular.element(document.getElementById('topanchor'));
		this._$document.scrollToElementAnimated(topAnchor);
	}
	kifejezesKereses(filter, e) {
		if (this.rendezvenyekListazoForm.$valid) {
			this.lista(filter, e);
		}
	}
	lista(filter, e) {
		if (e) {
			e.preventDefault();
		}
		filter = angular.extend((filter || this.filter), this.pageFilter);
		this._rendezvenyekService.lista(filter, this.narrow).then((response) => {
			let date = response.data.date;
			if (this.narrow) {
				this.aktualisRendezvenyek = response.data.response.docs.filter((item) => {
					return date <= new Date(item.vegdatum);
				});
			} else {
				this.aktualisRendezvenyek = response.data.response.docs.filter((item) => {
					return date <= new Date(item.vegdatum);
				}).reverse();
				this.korabbiRendezvenyek = response.data.response.docs.filter((item) => {
					return date > new Date(item.vegdatum);
				});
			}
			this.numFound = response.data.response.numFound;
			this.filter = filter;
		}, () => {
			this.technikaiHiba = true;
		});


	}
	getDayClass(data) {
		for (let esemenyDatum of this.esemenyDatumok) {
			let datum = esemenyDatum;
			if (datum.getYear() == data.date.getYear() && datum.getMonth() == data.date.getMonth() && datum.getDate() == data.date.getDate()) {
				return 'active';
			}
		}
	}
	_naptar() {
		this._rendezvenyekService.naptar().then((response) => {
			this.esemenyDatumok = response;
		}, () => {
			this.technikaiHiba = true;
		});
	}
}

export default angular.module(MODULE_NAME, [rendezvenyekServiceModule, duScroll])
	.component('rendezvenyekKereso', {
		controller: RendezvenyekKeresoController,
		template: template(),
		bindings: {
			elosztoUrl: '@',
			pageNumber: '<',
			narrow: '<'
		}
	}).name;



// WEBPACK FOOTER //
// ./source/applications/rendezvenyek/rendezvenyek-kereso/rendezvenyek-kereso.js